import { AvatarStyled, Box, SideSheetContentCol, SideSheetBody, Theme } from '@bechtel/gds';
import { CommodityStatusCode } from '@bechtel/types';
import styled, { css } from 'styled-components';
import { WeldDetailStyledProps } from './types';

interface WeldoutItemStyledProps {
  theme: Theme;
  status?: CommodityStatusCode;
  isAssigned?: boolean;
}

const getAssignedColor = (props: WeldoutItemStyledProps) => {
  return props.isAssigned
    ? css`
        background-color: ${props.theme.colors.bechtel.blue[500]};
        border: 1px solid ${props.theme.colors.bechtel.blue[500]};
      `
    : css`
        background-color: transparent;
        border: 1px solid ${props.theme.colors.grey[500]};
      `;
};

const getBackgroundColor = (props: WeldoutItemStyledProps) => {
  switch (props.status) {
    case CommodityStatusCode.VT_APPROVED:
      return css`
        background-color: ${props.theme.colors.green[500]};
        border: 1px solid ${props.theme.colors.green[500]};
      `;
    case CommodityStatusCode.CLAIMED:
    case CommodityStatusCode.FITUP_INSPECTION:
      return css`
        background-color: ${props.theme.colors.orange['000']};
        border: 1px solid ${props.theme.colors.orange['000']};
      `;
    case CommodityStatusCode.BLOCKED:
      return css`
        background-color: ${props.theme.colors.red[500]};
        border: 1px solid ${props.theme.colors.red[500]};
      `;
    case CommodityStatusCode.VT_SENT_BACK:
      return css`
        background-color: ${props.theme.colors.purple[500]};
        border: 1px solid ${props.theme.colors.purple[500]};
      `;
    case CommodityStatusCode.READY_TO_WELD:
      return getAssignedColor(props);

    case CommodityStatusCode.SENT_BACK_TO_PIPING:
      return css`
        background-color: ${props.theme.colors.grey[500]};
        border: 1px solid ${props.theme.colors.grey[500]};
      `;
    case CommodityStatusCode.FITUP_REQUESTED:
      return css`
        background-color: ${props.theme.colors.yellow[300]};
        border: 1px solid ${props.theme.colors.yellow[300]};
      `;
    default:
      return getAssignedColor(props);
  }
};
export const WeldoutItemStyled = styled(Box)<WeldoutItemStyledProps>`
  ${({ theme }) => css`
    width: ${theme.spacings[400]};
    height: ${theme.spacings[700]};
    border-radius: ${theme.spacings[200]};
    margin-right: ${theme.spacings[400]};
  `}
  ${getBackgroundColor}
`;
export const WeldAddCrewStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[100]};
    color: ${theme.colors.bechtel.blue[700]};
    border-width: 1px;
    margin-right: ${theme.spacings[450]};
  `};
`;
export const WeldDetailStyled = styled(Box).attrs({
  pt: { sm: '450' },
  px: { sm: '500' },
  pb: { sm: '550' },
  flexDirection: { sm: 'column' },
})<WeldDetailStyledProps>`
  &:hover {
    background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
  }
  background-color: ${(props: WeldDetailStyledProps) =>
    props.isActive ? ({ theme }) => theme.colors.bechtel.blue[100] : ({ theme }) => theme.colors.white};

  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
`;

export const WeldSideSheetContentColStyled = styled(SideSheetContentCol)`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`;

const boxShadow =
  '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);';

export const WeldDetailSideSheetBodyStyled = styled(SideSheetBody)`
  box-shadow: ${boxShadow};
`;

export const WeldDetailSideSheetContentColStyled = styled(SideSheetContentCol)`
  box-shadow: ${boxShadow};
`;
